export const T11 = {
    "columns": 4,
    "rows": 1.25,
    "visual": {
        "id": 14,
        "type": "summary",
        "colorTheme": "colorTheme1",
        "title": "Sales Performance Summary",
        "binding": {
            "data": {
                "title": '',
                "value": '',
                "displayTarget": true,
                "endpoint": "T11",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "AgentCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {

                    }
                }
            }
        }
    }
}